<template>
  <footer>
   <section class="footer-color">
    <div class="container">
      <div class="top mb-5">
        <div class="row">
          <div class="col-lg-7"></div>
          <div class="col-lg-5 col-md-9 col-12">
            <p class="mb-3 fw-bold">Get Notified on our next Bootcamp and upcoming programme</p>
            <div class="mb-3 position-relative notify-section">
              <input
                type="email"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="name@example.com"
              />
              <button class="btn btn-primary notify-btn">Notify</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="sketch"></div>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-4 skell mb-3">
          <div class="logo">
            <img
              src="../assets/Images/footer-logo.png"
              alt="footer"
              class="img-fluid"
            />
          </div>
          <div class="amet">
            <p>
              Amet minim mollit non deserunt <br />
              est sit aliqua dolor do amet sint.
            </p>
          </div>
         <div class="position-relative">
         <div class="social-abs">
          <div class="social">
            <div class="choice">
              <a href="https://web.facebook.com/profile.php?id=100092011904011&mibextid=ZbWKwL&_rdc=1&_rdr" target="_blank">
                <img
                  src="../assets/Images/facebook.png"
                  alt="facebook"
                  class="img-fluid"
                />
              </a>
            </div>
            <div class="choice">
              <a href="https://twitter.com/FhenixAfrica" target="_blank">
                <img
                  src="../assets/Images/twitter.png"
                  alt="twitter"
                  class="img-fluid"
                />
              </a>
            </div>
            <div class="choice">
              <a href="https://www.linkedin.com/company/fhenix-africa/about/" target="_blank">
                <img
                  src="../assets/Images/indelin.png"
                  alt="linkin"
                  class="img-fluid"
                />
              </a>
            </div>
          </div>
         </div>
         </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-4 skell mb-3">
          <div class="details">
            <small class="quick">Quick Links</small>
            <router-link to="/" class="set">Home</router-link>
            <router-link to="/" class="set">About</router-link>
            <router-link to="/" class="set">Services</router-link>
           
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-3 mb-3">
          <div class="details">
            <small>Services</small>
            <router-link to="/" class="set">Training</router-link>
            <router-link to="/" class="set">Talent Outsourcing</router-link>
            <router-link to="/" class="set">Co-Workspace</router-link>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-3 mb-3">
          <div class="info">
            <small class="contact">Contact Us</small>
            <div class="inform">
              <small>Telephone</small>
              <p>+ (234) 7069968976</p>
            </div>
            <div class="inform">
              <small>Email Address</small>
              <p>info@fhenixafrica.com </p>
            </div>
            <div class="inform">
              <small>Landline</small>
              <p>+ (234) 9070114841 </p>
            </div>
            <div class="inform">
              <small>Office Address</small>

              <p>
                Visit us at 27B Grace Bill Road, Eket, <br> +(234)
                7069968976
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
   </section>
   <section class="d-flex justify-content-center align-items-center py-3">
    <p class="text-primary mb-0 fw-bold"><span class="fw-bold">&copy;</span> FHENIX {{ currentYear }} </p>
   </section>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
};
</script>

<style scoped>
.notify-btn {
  position: absolute;
  top: 6px;
  right: 3px;
}

.notify-section input {
  padding: 12px;
}
.footer-color {
  background: #d8e2f3;
  padding-top: 50px;
  padding-bottom: 30px;
}

.set {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 124.5%;
  color: #595959;
  text-decoration: none;
}
.set {
  transition: all 0.5s ease-out;
}
.set:hover {
  color: blue ;
}
.social a {
  text-decoration: none;
  
}
.social {
  display: flex;
  gap: 6px;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
/* styling of the small tags */
.inform small {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
  color: #4a4a4a;
}
.details small {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 124.5%;
  color: #595959;
}
.contact {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 124.5%;
  color: #595959;
}

/* styling of the p ttags */
.amet p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}

.inform p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-transform: capitalize;
  color: #4a4a4a;
}
p {
  margin-top: 0.2rem;
}

.sketch {
  width: 411px;
  height: 343px;
  position: absolute;
  left: 0px;
  margin-top: -54px;
  background: url(../assets/Images/Ellipse.png);
  object-fit: contain;
  background-size: cover;
  z-index: 5;
}

.social-abs {
  position: absolute;
  z-index: 300;
}

/* ffor the responsiveness */
@media screen and (max-width: 768px) {
  .skell {
    margin-bottom: 1.5rem;
  }

  .details a {
    
  }


  .social-abs {
    position: relative;
  }

}
@media screen and (max-width: 425px) {
  .sketch {
    width: 100%;
    height: 257px;
  }
  .info {
    margin-top: 21px;
  }
  /* .footer-color {
    width: 630px;
  } */

  .quick {
    margin-top: 70px;
  }

  .set {
    font-size: 18px;
  }

  .inform p {
    font-size: 17px;
    font-weight: 650;
  }

  .inform small {
    font-size: 21px;
  }
}
</style>